module.exports = __webpack_public_path__ + "bb5f0c7202ecc90bc7c04f09e05fb9b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/low_10.jpg
// module id = 1726
// module chunks = 5